// components/Logo.jsx
import React from 'react';

const Logo = ({ theme }) => (
    <svg className="w-96 h-24" viewBox="0 0 450 100">
        <circle
            cx="60"
            cy="50"
            r="30"
            fill="none"
            stroke={theme === 'tech' ? '#fff' : '#000'}
            strokeWidth="3"
        />
        <path
            d="M45,60 L60,60 L60,40 L45,40"
            fill="none"
            stroke={theme === 'tech' ? '#fff' : '#000'}
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M60,25 A25,25 0 0 1 85,50"
            fill="none"
            stroke={theme === 'tech' ? '#3498db' : '#2980b9'}
            strokeWidth="4"
            strokeLinecap="round"
        />
        <text
            x="100"
            y="45"
            fontFamily="Arial, sans-serif"
            fontSize="24"
            fill={theme === 'tech' ? '#fff' : '#333'}
        >
            Songer Consulting
        </text>
        <text
            x="100"
            y="70"
            fontFamily="Arial, sans-serif"
            fontSize="12"
            fill={theme === 'tech' ? '#fff' : '#333'}
        >
            Innovating IT Solutions, elevating success
        </text>
    </svg>
);

export default Logo;